import React, { createContext, useCallback, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { api } from '@service/api';
import { useTheme } from '@hooks/theme';

export interface UserData {
  email: string;
  name: string;
  defaultTheme: string;
  groupUser: number;
  gender: string;
  uuid: string;
}

interface AuthState {
  token: string;
  refreshToken: string;
  user: UserData;
}

interface SignInCredentials {
  email: string;
  password: string;
}

interface AuthContextData extends AuthState {
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
  updateDataUser({}: any): void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem('jwt');
    const refreshToken = localStorage.getItem('refreshToken');
    const user = localStorage.getItem('user');

    if (token && refreshToken && user) {
      return { token, refreshToken, user: JSON.parse(user) };
    }

    return {} as AuthState;
  });

  const history = useHistory();

  const signIn = useCallback(
    async ({ email, password }) => {
      console.log('>>> signIn:email:', email, password);

      const data = await api.post('/users/login', {
        email: email,
        password: password,
      });

      console.log('>>> signIn:data:', data.data);
      const token = data.data.data.token;
      const refreshToken = data.data.data.refreshToken || 6000;

      // const user = await api.get('/users/current', {
      //   headers: {
      //     authorization: token,
      //   },
      // });

      const regirterUser = {
        name: data.data.data.name,
        email: data.data.data.email,
        defaultTheme: data.data.data.defaultTheme,
        groupUser: data.data.data.id_group,
        groupName: data.data.data.nameGroup,
        gender: data.data.data.gender,
        uuid: data.data.data.uuid,
        departmentId: data.data.data.departmentId,
        departmentAcronym: data.data.data.departmentAcronym,
        adjutancyId: data.data.data.adjutancyId,
        adjutancyName: data.data.data.adjutancyName,
        isCollaborator: data.data.data.isCollaborator,
        register: data.data.data.registration_velti,
        cpf: data.data.data.id_individual_register,
        bossRegister: data.data.data.bossRegister,
        bossName: data.data.data.bossName,
        firstAccess: data.data.data.firstAccess,
        // timeStampOut: data.data.data.timeStampOut,
        // dateTimeOut: data.data.data.dateTimeOut,
      };

      // console.log('>>> signIn:data:', data.data.data);
      // console.log('>>> signIn:regirterUser:', regirterUser);
      console.log('>>> signIn:timeStampOut:', data.data.data.timeStampOut);

      localStorage.clear();
      localStorage.setItem('jwt', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('timeStampOut', data.data.data.timeStampOut);
      localStorage.setItem('logged', data.data.success);

      localStorage.setItem('user', JSON.stringify(regirterUser));

      setData({
        token,
        refreshToken,
        user: regirterUser,
      });
      // whats.defaults.headers.authorization = token;

      // history.push('/admin/dashboard');
      return;
    },
    [history],
  );

  const signOut = useCallback(() => {
    localStorage.clear();
    setData({} as AuthState);
    history.push('/');
  }, [history]);

  const updateDataUser = useCallback(async (states: any) => {
    const token = localStorage.getItem('jwt') || '';
    const refreshToken = localStorage.getItem('refreshToken') || '';

    localStorage.clear();
    localStorage.setItem('jwt', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(states));

    setData({
      token,
      refreshToken,
      user: states,
    });
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token: data.token,
        user: data.user,
        refreshToken: data.refreshToken,
        signIn,
        signOut,
        updateDataUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be user within an AuthProvider');
  }

  return context;
}
